import { useToastStore, toast } from "@/stores/toast";

function useToast() {
  const toasts = useToastStore((state) => state.toasts);
  return {
    toasts,
    toast,
    dismiss: (toastId?: string) =>
      useToastStore.getState().dismissToast(toastId),
  };
}

export { useToast, toast };
